<template>
    <div class="col-lg-7 col-md-12 box-col-7">
              <div class="card o-hidden">
                <div class="card-header pb-0">
                  <h3>Marketing Expenses</h3>
                </div>
                <div class="bar-chart-widget">
                  <div class="bottom-content card-body">
                    <div class="row">
                      <div class="col-12">
                        <div id="chart-widget4">
                            <apexchart height="380" type="bar" :options="market.options" :series="market.series"></apexchart>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="card-body p-0">
                  
                </div>
              </div>
            </div>
</template>
<script>
import wcharts from '../../../data/widgets/charts/wcharts'
export default{
    name:'marketingPage',
    data(){
        return{
            market:wcharts.market
        }
    }
}
</script>